import { Map } from 'immutable';
import { rewriteAssetCdnUrl } from '../../../utils/assetCdnRewrite';

export const normalizeImages = (pictures) =>
  pictures.map((pic) => {
    let large = pic.get('image_url');
    if (!large) {
      large = pic.get('large');
    }

    let medium = pic.get('image_medium_url');
    if (!medium) {
      medium = pic.get('medium');
    }

    return Map({
      large: large ? rewriteAssetCdnUrl(large) : large,
      medium: medium ? rewriteAssetCdnUrl(medium) : medium,
    });
  });

// The API exposes list totals as a response header, which fromJS turns into
// either a header Map (axios object) or a List of [key, value] pairs
// depending on the environment — same duality storage.js handles.
export const readTotalFromHeaders = (headersPayload) => {
  if (!headersPayload || typeof headersPayload.toJS !== 'function') {
    return '0';
  }
  const headers = headersPayload.toJS();
  if (Array.isArray(headers)) {
    return String(
      headers.find((x) => Array.isArray(x) && x[0] === 'total')?.[1] ?? 0,
    );
  }
  if (headers && typeof headers === 'object') {
    return String(headers.total ?? headers.Total ?? 0);
  }
  return '0';
};
